// eslint-disable-next-line import/prefer-default-export
export const PRODUCT_LIST = "PRODUCT_LIST"
